import React from 'react';
import ChimeRegionProvider from 'src/components/provider/ChimeRegionProvider';
import BackendProvider from 'src/components/provider/BackendProvider';
import AppStateProvider from 'src/components/provider/AppStateProvider';

// BaseProviders should be free of any dependencies NOT needed on the WelcomePage.
// This will ensure the initial bundle load contains only whats needed
export default function BaseProviders({ children }: WithChildren) {
  return (
    <AppStateProvider>
      <ChimeRegionProvider>
        <BackendProvider>{children}</BackendProvider>
      </ChimeRegionProvider>
    </AppStateProvider>
  );
}
